import { render, staticRenderFns } from "./WizardText.vue?vue&type=template&id=861aa528"
import script from "./WizardText.vue?vue&type=script&lang=ts"
export * from "./WizardText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports